
import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';


import CaffenioDriveAPI from '../../../services/SoporteMacsTools';

import Loading from '../../util/loading/Loading';
import  NoItems  from "../../util/noitems/NoItems";
import Field from '../../util/field/Field';
import Modal from '../../util/modal/Modal';
import AcceptModal from '../../util/acceptModal/AcceptModal';
import ErrorMessages from '../../../util/validation-error-messages';
import MacForm from './MacForm';

export const CaffenioMacs = (props) => { 
    if (!props.location.state) {
        props.history.push(`/puntos-de-venta`);
    }
    
    const [state, setState] = useState({
        caffenio: props.location.state ? props.location.state.caffenio : null,
        caffenioId: props.location.state ? props.location.state.caffenioId : 0,
        isLoading: false,
        showConfirm:false,
        showForm:false,
        selectedItem: null,
        arrMacs:[],
        arrVersions:[{value:"Android",  label:"Android"}, {value: "Win 10", label:"Win 10"}, {value:"Win 11",  label:"Win 11"}],
        arrTipoMac:[{value: 1, label:"Drive"}, {value: 2, label:"Servidor"}]
    });

    /**Carga información del form */
    useEffect(() => {        
        setState({
            ...state,
            isLoading: true 
        });

        getDate();

        
    }, []);

    const getDate = () => {
        let arrMacs = [];
        
        CaffenioDriveAPI.getAllPdv(state.caffenioId)
        .then(response =>             
            arrMacs = response.data           
            
        ).catch(err => {
            setState({
                ...state,
                isLoading: false
            })
            if (err.response)
                toast.error(err.response.data.Message)
            else
                toast.error(ErrorMessages.SinConexion)
        }).finally(() => setState({
            ...state,
            arrMacs,            
            isLoading: false,
            
        }));
    }

    const handleGoBack = () => {
        window.history.back();
    }

    const handlesSaveMacAddress = (values) => {
        let arrMacs = [...state.arrMacs];
        let showForm = true;
        let selectedItem = {...state.selectedItem}
        let data = {...values}
        data["IdCaffenio"] = state.caffenioId
        CaffenioDriveAPI.addMac(values)
        .then(response =>{             
            showForm=false;
            selectedItem=null;
            arrMacs = response.data  
        }).catch(err => {
            if (err.response)
                toast.error(err.response.data.Message)
            else
                toast.error(ErrorMessages.SinConexion)
        }).finally(() => setState({
            ...state,
            arrMacs, 
            showForm, 
            selectedItem,          
            isLoading: false,            
        }));

    }

    const changeStatus = () => {        
        setState({...state, isLoading:true});
        let arrMacs = [...state.arrMacs];
        let selectedItem = {...state.selectedItem}
        let showConfirm = state.showConfirm
        selectedItem["IdCaffenio"] = state.caffenioId
        selectedItem.Active = !selectedItem.Active
        CaffenioDriveAPI.addMac(selectedItem).then(response => {
            toast.success("Estatus actualizado.")
            selectedItem=null;
            showConfirm=false;
            arrMacs = response.data;
        }).catch(err => {
            if(err.response)
                toast.error(err.response.data.Message)
            else
                toast.error(ErrorMessages.SinConexion)
        })
        .finally(() => setState({
            ...state,
            arrMacs, 
            showConfirm,
            selectedItem:null,          
            isLoading: false,            
        }));
    } 

    return ( 
        <div>
            {
                state.isLoading &&
                <Loading
                    isFullscreen={true}
                    isLoading={state.isLoading}
                    width='100px'
                    height='100px'
                />
            }   
            <div className="card">
                <div className="card-header">
                    <div className="card-header-title is-size-4 center-text">
                        <span style={{ position: "absolute", left: 25 }} className="is-primary tooltip" data-tooltip="Ir Atrás">
                            <i
                                className="fa fa-arrow-left"
                                style={{ cursor: "pointer", color: "#91BA43" }}
                                onClick={handleGoBack}
                            />
                        </span>
                        
                        <div>MACs en Punto de Venta</div>
                        <span style={{ cursor: "pointer", marginLeft:25 }} className="is-primary tooltip" data-tooltip="Crear">
                            <i className="fa fa-plus is-primary"  onClick={() => setState({...state, showForm:true})} ></i>
                        </span>

                        
                        
                    </div>
                </div>
                <div className="card-content">
                    <div>
                        {state.arrMacs && state.arrMacs.length !== 0 
                        ? 
                        <table className="table is-fullwidth">
                            <thead>
                                <tr>
                                    <th>idMac</th>
                                    <th>Descripción</th>
                                    <th>MacAddress</th>
                                    <th>Estatus</th>                                    
                                    <th>Vesion SO</th>
                                    <th>Acciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                {state.arrMacs.map((item, index) => {
                                    return (
                                        <tr key={index}>  
                                            <td>{item.Id}</td>
                                            <td>{item.Description}</td>                                            
                                            <td>{item.Address}</td>                                            
                                            <td>
                                                <Field label="" isHorizontal>
                                                        <input   
                                                            type="checkbox"
                                                            name="Active"
                                                            className="switch"
                                                            checked={item.Active}
                                                            onChange={() => {}}
                                                        />
                                                        <label htmlFor="Active" onClick={(e) => {
                                                            e.stopPropagation();
                                                            setState({...state, selectedItem:item, showConfirm: true})
                                                            
                                                        }}/>
                                                    </Field>
                                            </td>
                                            <td>{item.SoVersion} </td>     
                                            <td>
                                                <button className="button is-small tableAction is-success tooltip" data-tooltip="Editar" onClick={(e) => {
                                                    e.stopPropagation();
                                                    setState({...state, selectedItem: item, showForm:true});
                                                }
                                                }>
                                                    <span className="icon">
                                                        <i className="fa fa-edit" />
                                                    </span>
                                                </button>
                                            </td>                                       
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </table> 
                        : <NoItems itemName="drives"/>}
                    </div>
                </div>
            </div>
            {state.showConfirm && <AcceptModal
                modalTitle="Confirmar"
                modalBody={<p>¿Está seguro que desea cambiar el estatus?</p>}
                isActive={state.showConfirm}
                willSave
                done={() => changeStatus()}
                cancel={() => setState({...state, selectedItem:null, showConfirm:false })}
            />}
            {state.showForm  && 
                <Modal
                    showModal={state.showForm}
                    modalTitle={`${state.selectedItem != null ?  "Editar direción MAC" : "Nueva dirección MAC"} `}
                    width="40%"
                    cancel = {() => setState({...state, showForm: false,  selectedItem: null})}
                >
                    <MacForm
                        selectedItem={state.selectedItem}
                        arrVersions={state.arrVersions}
                        arrTipoMac={state.arrTipoMac}
                        save={(values) => handlesSaveMacAddress(values)}
                        caffenioId={state.caffenioId}

                    />
                    
                </Modal>
            }
        </div>
    );

}

export default CaffenioMacs;